module.exports = __webpack_public_path__ + "img/2.3c2fb733.png";